import { Box, Typography } from '@material-ui/core';
import React from 'react';

import MexcIcon from '../../common/images/dashboard/mexc-logo.png';
import PancakeswapIcon from '../../common/images/dashboard/pancakeswap-logo.png';
import { ReactComponent as StarsIcon } from '../../common/svg/dashboard/dashboard-stars-icon.svg';
import { Button } from '../core/button/Button';
import styles from './DashboardPurchase.module.css';

export interface DashboardPurchaseProps {
  purchaseOnClick: () => void;
}

export const DashboardPurchase: React.FC<DashboardPurchaseProps> = props => {
  const { purchaseOnClick } = props;

  return (
    <Box
      className={`${styles.background} m-5 md:m-0 lg:w-96 lg:h-130 p-5 flex flex-col gap-3 justify-center items-center rounded-lg flex-grow`}
    >
      <StarsIcon />
      <div className={styles.title}>MOGUL</div>
      <Typography variant="body2" className="text-center">
        The official in-app currency of Mogul Productions. MOGUL are used to
        purchase Digital Collectibles, rewards, vote on movies, governance, and
        to participate in growth farming.
      </Typography>
      <Button className="w-full" onClick={purchaseOnClick}>
        Purchase
      </Button>

      <Box className="w-full flex justify-between gap-4">
        <Button
          kind="secondary"
          className="w-full gap-2"
          style={{ paddingLeft: '1rem', paddingRight: '1rem' }}
          onClick={() =>
            window.open(
              'https://pancakeswap.finance/swap?inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0x88fd59e1DD3715A98bb66149DA9c944d9E795c12',
              '_blank',
            )
          }
        >
          <img height="24" width="auto" src={PancakeswapIcon} alt="pancake" />
          Pancakeswap
        </Button>
        <Button
          kind="secondary"
          className="w-full gap-2"
          style={{ paddingLeft: '1rem', paddingRight: '1rem' }}
          onClick={() =>
            window.open(
              'https://www.mexc.com/exchange/MOGUL_USDT?_from=search_spot_trade',
              '_blank',
            )
          }
        >
          <img height="24" width="auto" src={MexcIcon} alt="mexicon" />
          MEXC
        </Button>
      </Box>
    </Box>
  );
};
